
/* ===== index.html inline @line 1814 ===== */

(function () {
  const { Engine, World, Bodies, Body, Vector } = Matter;

  // Переменные для engine и world
  let engine, world, ctx, canvas, stageBox, dots, animate;

  // Функция инициализации анимации
  function initAnimation() {
    engine = Engine.create({ gravity: { x: 0, y: 1 }, enableSleeping: true });
    world = engine.world;

    const R = 7;
    const GAP = 120;
    const PHYS_R = R + GAP / 20;
    const GRID_DENSITY = 0.85;
    const CURSOR_RADIUS = 80;
    const FORCE_SCALE = 0.0002;

    function fitCanvas() {
      const rect = canvas.parentElement.getBoundingClientRect();
      const scale = window.devicePixelRatio || 1;
      canvas.width = rect.width * scale;
      canvas.height = rect.height * scale;
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';
      ctx.setTransform(scale, 0, 0, scale, 0, 0);
      return rect;
    }

    stageBox = fitCanvas();
    window.addEventListener('resize', fitCanvas);

    const baseCols = Math.floor(stageBox.width / (PHYS_R*2));
    const baseRows = Math.floor(stageBox.height / (PHYS_R*2));
    const cols = Math.max(1, Math.floor(baseCols * GRID_DENSITY));
    const rows = Math.max(1, Math.floor(baseRows * GRID_DENSITY));
    const xSpacing = cols > 1 ? (stageBox.width - 2*PHYS_R)/(cols - 1) : 0;
    const clusterH = stageBox.height * 0.45;
    const ySpacing = rows > 1 ? (clusterH - 2*PHYS_R)/(rows - 1) : 0;

    const targetOffsetY = stageBox.height - clusterH;
    const dropRange = stageBox.height;

    dots = [];
    for(let r=0; r<rows; r++){
      for(let c=0; c<cols; c++){
        const waveY = Math.sin((c/cols)*Math.PI*3)*20;
        const finalY = targetOffsetY + PHYS_R + r*ySpacing + waveY;
        const initialY = finalY - Math.random()*dropRange;
        const x = cols === 1 ? stageBox.width/2 : PHYS_R + c*xSpacing;
        dots.push(Bodies.circle(x, initialY, PHYS_R, {
          restitution: 0.2,
          friction: 0.1,
          frictionAir: 0.05,
          sleepThreshold: 30
        }));
      }
    }
    World.add(world, dots);

    const wall = PHYS_R;
    World.add(world, [
      Bodies.rectangle(stageBox.width/2, stageBox.height + wall/2, stageBox.width, wall, { isStatic: true }),
      Bodies.rectangle(-wall/2, stageBox.height/2, wall, stageBox.height, { isStatic: true }),
      Bodies.rectangle(stageBox.width + wall/2, stageBox.height/2, wall, stageBox.height, { isStatic: true })
    ]);

    window.addEventListener('mousemove', e => {
      const rect = canvas.getBoundingClientRect();
      const mouse = Vector.create(e.clientX - rect.left, e.clientY - rect.top);
      dots.forEach(dot => {
        if(dot.isSleeping) Body.set(dot, 'isSleeping', false);
        const dir = Vector.sub(dot.position, mouse);
        const dist = Vector.magnitude(dir);
        if(dist < CURSOR_RADIUS && dist > 1){
          const strength = FORCE_SCALE * (CURSOR_RADIUS - dist);
          Body.applyForce(dot, dot.position, Vector.mult(Vector.normalise(dir), strength));
        }
      });
    });

    // Запуск анимации
    animate = function () {
      Engine.update(engine, 1000/60);
      ctx.clearRect(0, 0, stageBox.width, stageBox.height);
      ctx.fillStyle = '#ffffff';
      dots.forEach(b => {
        const x = Math.round(b.position.x);
        const y = Math.round(b.position.y);
        ctx.beginPath();
        ctx.arc(x, y, R, 0, Math.PI*2);
        ctx.fill();
      });
      requestAnimationFrame(animate);
    };

    animate(); // Начинаем анимацию
  }

  // Ждём появления .stage в области видимости
  function watchForVisibility() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          canvas = document.querySelector('.world');
          if (!canvas) return console.error("Canvas не найден!");

          ctx = canvas.getContext('2d');

          initAnimation(); // Инициализируем анимацию
          observer.disconnect(); // Больше не наблюдаем
        }
      });
    }, { threshold: 0.1 });

    const target = document.querySelector('.stage');
    if (target) {
      observer.observe(target);
    } else {
      console.warn("&#x274C; .stage не найден");
    }
  }

  // Ждём полной загрузки DOM
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(watchForVisibility); // Стартуем наблюдение
})();
